import { Class, fetch2} from '../utils'

const serviceUrl = "https://dawa.aws.dk";

export const Query = Class (
  {
    options: null,
    initialize: function (options) {
      this.options = Object.assign({}, options);
      if (typeof this.options.kommunekode !== 'undefined')
        this.options.kommunekode = this.options.kommunekode.toString();
      //this.adresseQuery = new AdresseQuery(options);
      //this.vejQuery = new VejQuery(options);
    },
	
    query: async function (){
      //Hvis der er indtastet en gyldig vejkode så erstat query med navnet på vejen
      if (typeof this.options.kommunekode !== 'undefined' && this.options.kommunekode !== "*" && this.options.kommunekode.indexOf("|") === -1){
        //Kom er sat
        if (this.options.query.length === 4 ){
          //Der er fire tegn i en vejkode
          //let n = Math.floor(Number(this.options.query));
          //if( n !== Infinity && String(n) === this.options.query && n >= 0 ){
          let parseResult = parseInt(this.options.query)
          if( !isNaN(parseResult)){
            // Is an integer
            //https://stackoverflow.com/questions/10834796/validate-that-a-string-is-a-positive-integer
            let getOptions = {
              kode: this.options.query,
              kommunekode: this.options.kommunekode
            }
            let data = await new VejStykkeGetter().get(getOptions);
            if (typeof data!== 'undefined'){
              return [{type: "vejnavn", vejnavn: data.properties.navn}];
              //this.options.query = data.properties.navn;
            }
          }
        }
      }
      this.adresseQuery = new AdresseQuery(this.options);
      this.vejQuery = new VejQuery(this.options);
      await Promise.all([this.adresseQuery.query(), this.vejQuery.query()]);
      let searchResult = await this.buildSearchResult();
      return searchResult;
    },
	
    buildSearchResult: async function(){
      let adrCount = this.adresseQuery.getAdresseCount();
      const vejCount = this.vejQuery.getVejCount();
      const vejnavnCount = this.vejQuery.getVejnavnCount();
      const limit = this.options.limit;
    
      let result = [];

      if (adrCount === 0  && vejnavnCount === 0 ){
        return result;
      }else if ((adrCount > 0) && (adrCount <= limit || vejCount <= 1)){
        result = this.adresseQuery.buildAdresseResult(limit);
        if (this.options.showOneStreet){
          //Vis altid een vej, hvis der er fundet en (Sikrer, at man kan vælge vejen)
          if (vejCount === 1){
            //Vis den ene, der er fundet
            result = this.vejQuery.buildVejResult(limit).concat(result);
            return result;
          }else{
            // Eller konstruér een ud fra første adresse
            let data = await new AdgangsAdresseGetter().get(result[0].id);
            result = [
              {type: "vej",
                vejnavn: data.properties.vejstykke.navn,
                postnummer: data.properties.postnummer.nr,
                postdistrikt: data.properties.postnummer.navn,
                vejkode: data.properties.vejstykke.kode}
            ].concat(result);
            return result;
          }
        }else{
          return result;
        }
      }else if((vejCount > 0) && (vejCount <= limit || vejnavnCount == 1)){
        return this.vejQuery.buildVejResult(limit);
      }
      else if (vejnavnCount > 0){
        return this.vejQuery.buildVejnavnResult(limit);
      }
    },
	
    CLASS_NAME: 'Septima.Search.Dawa.Query'

  });

const AdresseQuery = Class (
  {
    response: null,

    initialize: function (options) {
      this.response = [];
      this.options = options;
		
    },
	
    query: async function (){
      if (this.options.query === ""){
        return;
      }else{
        const callParameters = {
          q: this.options.query,
          type: "adgangsadresse",
          side: 1,
          per_side: this.options.limit + 1,
          noformat: 1
        };
        if (typeof this.options.kommunekode !== 'undefined' && this.options.kommunekode !== "*"){
          callParameters.kommunekode = this.options.kommunekode;
        }
        let data = await fetch2(serviceUrl + "/adgangsadresser/autocomplete", {data: callParameters});
        let directResponse = data;
        directResponse = this.sortAdresseResponse(directResponse);
        callParameters.q = callParameters.q + " ";
        let data2 = await fetch2(serviceUrl + "/adgangsadresser/autocomplete", {data: callParameters});
        let blankAppendixResponse = data2;
        if (blankAppendixResponse.length === directResponse.length){
          this.response = directResponse;
        }else{
          for (let i = directResponse.length -1; i >=0; i--){
            let directAdr = directResponse[i];
            for (let j=0;j < blankAppendixResponse.length; j++){
              if (blankAppendixResponse[j].adgangsadresse.id === directAdr.adgangsadresse.id){
                directResponse.splice(i, 1);
              }
            }
          }
          this.response = blankAppendixResponse.concat(directResponse);
        }
        return;
      }
    },
	
    getAdresseCount: function (){
      return this.response.length;
    },
	
    buildAdresseResult: function (limit){
      const result = [];
      for (let i = 0; (i < this.response.length) && (result.length < limit); i++){
        const adr = this.response[i];
        result.push({type: "adgangsadresseinfo", tekst: adr.tekst, id: adr.adgangsadresse.id});
      }
      return result;
    },
	
    sortAdresseResponse: function(response){
      //	    {
      //	        "id": "0a3f507c-8d5d-32b8-e044-0003ba298018",
      //	        "href": "https://dawa.aws.dk/adgangsadresser/0a3f507c-8d5d-32b8-e044-0003ba298018",
      //	        "vejnavn": "Sortsøvej",
      //	        "husnr": "6",
      //	        "supplerendebynavn": null,
      //	        "postnr": "2730",
      //	        "postnrnavn": "Herlev",
      //	        "stormodtagerpostnr": null,
      //	        "stormodtagerpostnrnavn": null
      //	    }
      const sorter = function (r1, r2) {
        try {
          const h1 = parseInt(r1.adgangsadresse.husnr);
          const h2 = parseInt(r2.adgangsadresse.husnr);
          const p1 = parseInt(r1.adgangsadresse.postnr);
          const p2 = parseInt(r2.adgangsadresse.postnr);
          if (h1 === h2) {
            return (p1 - p2);
          } else {
            return (h1 - h2);
          }
        } catch (error) {
          return 0;
        }
      };
      return response.sort(sorter);
    },
	
    CLASS_NAME: 'Septima.Search.Dawa.AdresseQuery'

  });

export const AdgangsAdresseGetter = Class (
  {
    initialize: function(){
    },
	
    get: async function (id){
      let data = await fetch2(serviceUrl + "/adgangsadresser/" + id, {data: {srid: 25832, format: "geojson", struktur: "nestet"}});
      return data;
    },
    
    sq: async function(x, y){
      let data =  await fetch2(serviceUrl + "/adgangsadresser/reverse", {data: {srid: 25832, format: "geojson", struktur: "nestet", x: x, y: y}});
      return data;
    },
	
    CLASS_NAME: 'Septima.Search.Dawa.AdgangsAdresseGetter'

  });

export const VejQuery = Class (
  {
    options: null,
    response: null,
    vejCount: null,
	
    initialize: function (options) {
      this.options = options;
      this.response = [];
      this.vejCount = null;
    },
	
    query: async function (){
      const callParameters = {q: "", side: 1, per_side: this.options.limit + 1, noformat: 1};
      if (this.options.query !== ""){
        callParameters.q = this.options.query + "*";
      }
      if (typeof this.options.kommunekode !== 'undefined' && this.options.kommunekode !== "*"){
        callParameters.kommunekode = this.options.kommunekode;
      }
      let data = await fetch2(serviceUrl + "/vejnavne", {data: callParameters});
      this.response = data;
      return;
    },
	
    getVejCount: function (){
      let result = 0;
      if (this.vejCount === null){
        for (let i = 0; i < this.response.length; i++){
          let vejNavn = this.response[i];
          for (let j = 0; j < vejNavn.postnumre.length; j++){
            result++;
          }
        }
      }
      this.vejCount = result;
      return this.vejCount;
    },
	
    buildVejResult: function (limit){
      const result = [];
      for (let i = 0; (i < this.response.length) && (result.length < limit); i++){
        let vejNavn = this.response[i];
        for (let j = 0; (j < vejNavn.postnumre.length) && (result.length < limit); j++){
          let postNummer = vejNavn.postnumre[j];
          result.push({type: "vej", vejnavn: vejNavn.navn, postnummer: postNummer.nr, postdistrikt: postNummer.navn});
        }
      }
      return result;
    },
	
    getVejnavnCount: function (){
      return this.response.length;
    },
	
    buildVejnavnResult: function (limit){
      const result = [];
      for (let i = 0; (i < this.response.length) && (result.length < limit); i++){
        let vejNavn = this.response[i];
        let postNummer;
        if (vejNavn.navn.toLowerCase() === this.options.query.toLowerCase()){
          for (let j = 0; (j < vejNavn.postnumre.length) && (result.length < limit); j++){
            postNummer = vejNavn.postnumre[j];
            result.push({type: "vej", vejnavn: vejNavn.navn, postnummer: postNummer.nr, postdistrikt: postNummer.navn});
          }
        }else{
          if (vejNavn.postnumre.length === 1){
            postNummer = vejNavn.postnumre[0];
            result.push({type: "vej", vejnavn: vejNavn.navn, postnummer: postNummer.nr, postdistrikt: postNummer.navn});
          }else{
            result.push({type: "vejnavn", vejnavn: vejNavn.navn});
          }
        }
      }
      return result;
    },
	
    CLASS_NAME: 'Septima.Search.Dawa.VejQuery'

  });

export const VejStykkeGetter = Class (
  {
    initialize: function(){
    },
	
    get: async function (query){
      query.srid = 25832;
      query.format = "geojson";
      let data = await fetch2(serviceUrl + "/vejstykker", {data: query});
      return data.features[0];
    },
	
    CLASS_NAME: 'Septima.Search.Dawa.VejStykkeGetter'
  });
